
export const LiveCrStatus = {
  LIVE_CR_INITIATED: 'LIVE_CR_INITIATED',
  LIVE_CR_INITIALIZING: 'LIVE_CR_INITIALIZING',
  LIVE_CR_ACTIVE: 'LIVE_CR_ACTIVE',
  LIVE_CR_FAILED: 'LIVE_CR_FAILED',
};
